import * as React from 'react';
import { Footer } from '../../components/Footer';
import { useApplicationContext } from '../../utils/applicationContext';
import { IFooterInfo } from '../../types/footer';

export const FooterContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const footerInfo = config.getStrict<IFooterInfo>('job-vacancies-frontend.additionalInformation');

  return <Footer content={footerInfo} />;
};

FooterContainer.displayName = 'FooterContainer';
